// Sidebar width constants
export const MIN_DRAWER_WIDTH = 300;
export const DRAWER_CONTENT_PADDING = 24;
